import { render, staticRenderFns } from "./individualEntryForm.vue?vue&type=template&id=7063a84a&scoped=true&"
import script from "./individualEntryForm.vue?vue&type=script&lang=js&"
export * from "./individualEntryForm.vue?vue&type=script&lang=js&"
import style0 from "./individualEntryForm.vue?vue&type=style&index=0&id=7063a84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063a84a",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCard,QCardSection,QBtn,QSeparator,QIcon,QInput,QCardActions});
